import {App} from './App'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'
import {jsonRoute} from '@github-ui/react-core/json-route'
import {ConfirmationPage, WhitepaperIndex, WhitepaperPage, WhitepapersConfirmation} from './routes'
import {ResourceDetailsPage} from './routes/ResourceDetailsPage/ResourceDetailsPage'
import {IndexPage} from './routes/IndexPage/IndexPage'

registerNavigatorApp('resources', () => ({
  App,
  routes: [
    jsonRoute({path: '/resources/articles/:resource', Component: ResourceDetailsPage}),
    jsonRoute({path: '/resources/articles', Component: IndexPage}),
    jsonRoute({path: '/resources/whitepapers', Component: WhitepaperIndex}),
    jsonRoute({path: '/resources/whitepapers/:resource', Component: WhitepaperPage}),
    jsonRoute({path: '/resources/whitepapers/:resource/confirmation', Component: WhitepapersConfirmation}),
    jsonRoute({path: '/resources/:index', Component: IndexPage}),
    jsonRoute({path: '/resources/:index/:resource', Component: ResourceDetailsPage}),
    jsonRoute({path: '/resources/:index/:resource/confirmation', Component: ConfirmationPage}),
    jsonRoute({path: '/resources/insights/', Component: IndexPage}),
    jsonRoute({path: '/resources/insights/:slug', Component: ResourceDetailsPage}),

    jsonRoute({path: '/partners/resources', Component: IndexPage}),
    jsonRoute({path: '/partners/resources/:resource', Component: ResourceDetailsPage}),
    jsonRoute({path: '/education/teachers/toolbox/resources', Component: IndexPage}),
    jsonRoute({path: '/education/teachers/toolbox/resources/:resource', Component: ResourceDetailsPage}),
  ],
}))
